export type ArticleType = "post" | "event" | "document";

export class ShareUtil {
    private tenantId: string;
    private location: string;
    private isPublic?: boolean;
    constructor(tenantId: string, isPublic?: boolean) {
        this.tenantId = tenantId;
        this.location = window.location.href;
        this.isPublic = isPublic;
    }

    public getPortalUrl = (baseUrl: string, articleType: ArticleType, articleId: string, queryParams?: URLSearchParams): string => {
        let url: URL = this.buildUrl(baseUrl, articleType, articleId);

        url = this.addQueryParams(url, queryParams);

        return url.toString();
    };

    private buildUrl = (baseUrl: string, articleType: ArticleType, articleId: string): URL => {
        let segments: string[] = [];
        let url: URL;

        if (!this.tenantId) {
            segments = this.location.split("/public/");

            url = new URL(`${segments[0]}/public/${articleType}s/${articleId}`);
        } else {
            segments = this.location.split(this.tenantId);

            if (!baseUrl || this.isPublic) {
                url = new URL(`${segments[0]}${this.tenantId}/${this.isPublic ? "public/" : ""}${articleType}s/${articleId}`);
            } else {
                url = new URL(`${baseUrl}${articleId}`);
            }
        }

        return url;
    };

    private addQueryParams = (url: URL, queryParams?: URLSearchParams): URL => {
        if (queryParams) {
            queryParams.forEach((value: string, key: string) => {
                url.searchParams.append(key, value);
            });
        }

        return url;
    };
}
